module.exports = __webpack_public_path__ + "static/img/amex.d8677769.svg";